import React from "react";
import { Link, LinkProps } from "react-router-dom";

interface RouterLinkProps extends Omit<LinkProps, "ref"> {
  children: React.ReactNode;
  className?: string;
  to: string;
}

const RouterLink: React.FC<RouterLinkProps> = ({ children, ...props }) => {
  return React.createElement(Link as React.ComponentType<any>, props, children);
};

export default RouterLink;
